import React, { useEffect, useState } from "react";
import { ScrollText } from "lucide-react";
import api from "../../lib/api";
import { fmtDateTime } from "../../lib/time";
import { Label, EmptyState } from "../../components/common";

export default function Audit() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/audit").then((r) => setRows(r.data)).catch(() => {}); }, []);
  return (
    <div className="space-y-6">
      <div><Label>Governance</Label><h1 className="font-head text-2xl font-bold text-slate-900 sm:text-3xl">Audit Log</h1></div>
      {rows.length === 0 ? <EmptyState icon={ScrollText} title="No audit events" /> : (
        <div className="overflow-x-auto rounded-xl border border-slate-200 bg-white sv-scroll">
          <table className="w-full min-w-[640px] text-sm" data-testid="audit-table">
            <thead><tr className="border-b border-slate-200 text-left text-xs uppercase tracking-wide text-slate-400">
              <th className="p-3">Time</th><th>Actor</th><th>Action</th><th>Object</th></tr></thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id} className="border-b border-slate-100">
                  <td className="p-3 text-slate-400">{fmtDateTime(r.created_at)}</td>
                  <td className="text-slate-600">{r.actor_email || "system"}</td>
                  <td><span className="rounded bg-slate-100 px-2 py-0.5 font-mono text-xs text-slate-700">{r.action}</span></td>
                  <td className="text-slate-500">{r.object_type}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
